import { SchoolRepository } from '@xq/infrastructure';

export class IsSchoolNameUniqueInStateUseCase {
  static execute(schoolName: string, state: string, city: string) {
    const schoolRepository = new SchoolRepository();

    return schoolRepository.isSchoolNameUniqueInState(schoolName, state, city);
  }
}
